module.exports = __webpack_public_path__ + "img/c62f15a.png";